import {
    EDIT_DATA_SELECTED,
    SAVE_ALL_CONTRACT, SAVE_TABLE_DATA,SAVE_INFO_FACTOR_CONTRACT
} from "Stores/actionTypes";
import { updateObject } from "./utility";

const initialState = {
    contractData: [],
    tableDataContract: [],
    editRecord: null,
    infoFactorContract:null

};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_ALL_CONTRACT:
            return updateObject(state, {
                contractData: action.contractData,
            });
        case EDIT_DATA_SELECTED:
            return updateObject(state, {
                editRecord: action.editRecord,
            });
        case SAVE_TABLE_DATA:
            return updateObject(state, {
                tableDataContract: action.tableDataContract,
            });
      case SAVE_INFO_FACTOR_CONTRACT:
        return updateObject(state, {
          infoFactorContract: action.infoFactorContract,
        });
        default:
            return state;
    }
};

export default reducer;
